import React, { useState, useEffect } from "react";
import LegalPage from "../legal/LegalPage";
import { getTermsConditions } from "../../services/data.service";
import Loading from "../../assets/images/icons/loading.gif";

const TermsConditions = () => {
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const res = await getTermsConditions();
        if (res && res.data && res.data.data) {
          setData(res.data.data);
        }
      } catch (err) {
        console.error("Error fetching terms & conditions:", err);
      } finally {
        setLoading(false);
      }
    };
    fetchData();
  }, []);

  if (loading) {
    return (
      <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100vh' }}>
        <img src={Loading} alt="Loading..." style={{ width: '50px' }} />
      </div>
    );
  }

  if (!data) return <div>Failed to load terms &amp; conditions.</div>;

  return (
    <LegalPage
      data={data}
      bannerClassName="page-banner--tall"
      defaultDescription="These Terms & Conditions govern your access to and use of the NCET website and its online services. Please read them carefully before continuing."
    />
  );
};

export default TermsConditions;
